import * as React from "react";
import { observer } from "mobx-react";
import { SpedApuracaoStore } from "../../stores/sped/SpedApuracaoStore";
import { Alignment, Button, Classes, Dialog, FormGroup } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { formatCnpj } from "../../utils";
import { IEmpresa, newEmpresa } from "../../model";
import { toast } from "react-toastify";
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ptBR } from '@mui/x-date-pickers/locales';
import moment from "moment";
import ApuracaoSaidaTable from "./ApuracaoSaidaTable";
import { AppStore } from "../../stores/AppStore";
import { ResultadoStore } from "../../stores/resultados/ResultadoStore";
import dayjs from "dayjs";
import LoadingModal from "../loading/LoadingModal";
import { SpedStore } from "../../stores/sped/SpedStore";

@observer
export default class ApuracaoSaida extends React.Component<{}, {}> {

  obs = observable({
    selecione_ajuste_sped: null,
    loading: false as boolean,
    processando: false as boolean
  })

  constructor(props: any) {
    super(props);

  }

  /**
   * Ao montar o componente, verifica se existe o cookie "__DAE-DEI".
   * Se existir, restaura as informações salvas (abas, empresa, período,
   * modelo e data) nos stores e realiza a busca de dados DEI.
   * Após isso, o cookie é removido.
   */
  async componentDidMount() {

    const cookies_data = localStorage.getItem('__DAE-DEI');

    const cookies_json = JSON.parse(cookies_data)

    if (cookies_json && cookies_json.tab == "apuracao_saida") {

      SpedStore.obs.selectedTab = "apuracao"

      SpedApuracaoStore.obs.selectedTab = "apuracao_saida"

      SpedApuracaoStore.obs.selectedEmpresaSaida = cookies_json.empresa

      SpedApuracaoStore.obs.periodoSaida = cookies_json.periodo

      SpedApuracaoStore.obs.dataSaida = dayjs(moment(cookies_json.date_start).add(3, "hours").toDate())

      this.obs.loading = true

      await SpedApuracaoStore.handleBuscaApuracaoSaida(SpedApuracaoStore.obs.selectedEmpresaSaida.cnpj, SpedApuracaoStore.obs.periodoSaida)

      this.obs.loading = false

      localStorage.removeItem('__DAE-DEI');

    }

  }

  /**
 * Realiza a busca da apuração de ICMS, verificando as condições necessárias antes de efetuar a requisição de dados.
 * 
 * A função realiza as seguintes validações:
 * - Verifica se uma empresa foi selecionada (CNPJ).
 * - Verifica se o período de apuração está definido corretamente.
 * - Verifica se o ano do período de apuração é maior ou igual a 2000.
 * 
 * Caso alguma dessas condições não seja atendida, a execução é interrompida com o devido tratamento, como exibição de mensagens de aviso.
 * 
 * Após a validação, a função realiza a busca dos dados de apuração de saída para a empresa e o período selecionados.
 * 
 * @returns {Promise<void>} Retorna uma promise que resolve sem valor após a execução da busca de apuração.
 */
  async handleBuscaApuracao() {

    if (!SpedApuracaoStore.obs.selectedEmpresaSaida.cnpj) {
      toast.warning('Selecione uma empresa.', {});
      return
    }

    if (
      !SpedApuracaoStore.obs.periodoSaida 
      || !SpedApuracaoStore.obs.periodoSaida.length
      || SpedApuracaoStore.obs.periodoSaida.includes("Data inválida") 
      || SpedApuracaoStore.obs.periodoSaida.includes(null) 
      || SpedApuracaoStore.obs.periodoSaida.includes("")) {
      return
    }

    if (parseInt(moment(SpedApuracaoStore.obs.periodoSaida[0]).format("YYYY")) < 2000) return
    if (parseInt(moment(SpedApuracaoStore.obs.periodoSaida[1]).format("YYYY")) < 2000) return

    this.obs.loading = true

    await SpedApuracaoStore.handleBuscaApuracaoSaida(SpedApuracaoStore.obs.selectedEmpresaSaida.cnpj, SpedApuracaoStore.obs.periodoSaida)

    this.obs.loading = false

  }

  /**
 * Processa a apuração com os dados selecionados e realiza a busca de apuração.
 * 
 * A função coleta o CNPJ da empresa e o período de apuração a partir das variáveis de estado, cria um objeto de dados com essas informações, 
 * e chama a função `handleProcessar` para processar a apuração. 
 * Se o processamento for bem-sucedido, a função chama `handleBuscaApuracao` para buscar os resultados.
 * 
 * Após o processamento, a função fecha o modal de apuração.
 * 
 * @returns {Promise<void>} Retorna uma promise que resolve após o processamento e busca de apuração.
 */
  async handleProcessar() {

    if (!SpedApuracaoStore.obs.selectedEmpresaSaida.cnpj) {
      toast.warning('Selecione uma empresa.', {});
      return
    }

    if (
      !SpedApuracaoStore.obs.periodoSaida 
      || !SpedApuracaoStore.obs.periodoSaida.length
      || SpedApuracaoStore.obs.periodoSaida.includes("Data inválida") 
      || SpedApuracaoStore.obs.periodoSaida.includes(null) 
      || SpedApuracaoStore.obs.periodoSaida.includes("")) {

        toast.warning('Selecione um período.', {});
        return
    }

    let data = {
      cnpj: SpedApuracaoStore.obs.selectedEmpresaSaida.cnpj,
      period: SpedApuracaoStore.obs.periodoSaida[0]
    }

    this.obs.processando = true

    let resp = await SpedApuracaoStore.handleProcessar(data)

    this.obs.processando = false

    if (resp) this.handleBuscaApuracao()

  }

  /**
 * Atualiza o período de apuração e realiza a busca de apuração.
 * 
 * A função recebe um valor de data, verifica sua validade e calcula o início e o fim do mês da data fornecida. 
 * A data de início e fim do mês são então atribuídas ao período de saída (`periodoSaida`).
 * 
 * Em seguida, a função chama `handleBuscaApuracao` para buscar os dados de apuração.
 * 
 * @param {Object} value O valor da data selecionada, utilizado para calcular o início e o fim do mês.
 * 
 * @returns {void} Não retorna nenhum valor. Apenas atualiza o estado com o novo período e executa a busca de apuração.
 */
  async handlePeriodo(value) {

    const data = value && value.$d ? value.$d : ""

    SpedApuracaoStore.obs.dataSaida = value

    SpedApuracaoStore.obs.periodoSaida = [moment(data).startOf("month").format("YYYY-MM-DD"), moment(data).endOf("month").format("YYYY-MM-DD")]

    this.handleBuscaApuracao()

  }

  /**
 * Limpa os detalhes das apurações.
 * 
 * A função simplesmente define a variável `apuracoes` em `SpedApuracaoStore.obs` como `null`, limpando assim quaisquer dados ou detalhes previamente carregados.
 * 
 * @returns {void} Não retorna nenhum valor. Apenas limpa os dados de apuração.
 */
  onCloseDetalhes() {

    SpedApuracaoStore.obs.apuracoes = null

  }

  render() {

    let empresaText = SpedApuracaoStore.obs.selectedEmpresaSaida.cnpj != ""
      ? `${SpedApuracaoStore.obs.selectedEmpresaSaida.razao_social.substring(0, 38)}... (${formatCnpj(SpedApuracaoStore.obs.selectedEmpresaSaida.cnpj)})`
      : "Selecione uma empresa";

    return (
      <>

        <MDBRow style={{ display: "flex", width: "100%", marginBottom: "10px" }}>

          <MDBCol md="4">
            <FormGroup className="empresaSelect" label="Empresa">
              <EmpresaSelect
                items={EmpresaStore.sortedEmpresas}
                itemRenderer={renderEmpresa}
                itemPredicate={filterEmpresa}
                onItemSelect={(e: IEmpresa) => { SpedApuracaoStore.obs.selectedEmpresaSaida = e; this.handleBuscaApuracao() }}
                inputProps={{ placeholder: "Filtrar uma empresa" }}
              >
                <Button
                  text={empresaText}
                  rightIcon="double-caret-vertical"
                  alignText={Alignment.LEFT}
                />
              </EmpresaSelect>
            </FormGroup>
          </MDBCol>

          <MDBCol md="2">
            <FormGroup label="Período">
              <LocalizationProvider
                localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText} 
                adapterLocale={"pt-br"}
                dateAdapter={AdapterDayjs}>
                <DatePicker value={SpedApuracaoStore.obs.dataSaida} className="input-data-apuracao" views={['month', 'year']} onChange={(value) => this.handlePeriodo(value)} format="MM/YYYY" slotProps={{ textField: { size: 'small' } }} />
              </LocalizationProvider>
            </FormGroup>
          </MDBCol>

          <MDBCol>
            <Button
              style={{ marginTop: 28 }}
              text="Buscar"
              intent="primary"
              onClick={() => this.handleBuscaApuracao()}
              loading={this.obs.loading}
            />
          </MDBCol>

          <MDBCol>
            <Button
              style={{ marginTop: 28, float: "right" }}
              text="Processar Apuração"
              className="btnDefault btnBuscarNfe btnVerde"
              onClick={() => this.handleProcessar()}
              loading={this.obs.processando}
            />
          </MDBCol>

        </MDBRow>

        {SpedApuracaoStore.obs.apuracoes ?

          <ApuracaoSaidaTable item={SpedApuracaoStore.obs.apuracoes} onClose={this.onCloseDetalhes.bind(this)} />

          : <></>

        }

        <LoadingModal open={this.obs.processando} onClose={() => this.obs.processando = false} title={"Processando apuração"} />

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }} />

      </>
    )
  }
}